var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "679493932d9052bd119c9fa089f7b0e38ad879f7"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["butternutbox-frontend@butternut"] = {
  id: "679493932d9052bd119c9fa089f7b0e38ad879f7"
};